import Placeholder from '@atlaskit/react-ufo/placeholder';
import { ErrorBoundary } from '@dev-agents/error-boundary';
import { lazy } from 'react';

import { LoadingSkeleton } from '../common/components/skeleton/skeleton';
import { AggRelayEnvironmentProvider } from '../controllers/agg-relay-environment-provider';

const AppRouteComponent = lazy(() =>
	import('./app/app-route').then(({ AppRouteComponent }) => ({ default: AppRouteComponent })),
);

export const AppRouteComponentWithAggHeaders = () => {
	return (
		<ErrorBoundary componentName="AppRouteComponentWithAggHeaders">
			<Placeholder name="dev-agents-app-with-agg-headers" fallback={<LoadingSkeleton />}>
				<AggRelayEnvironmentProvider>
					<AppRouteComponent />
				</AggRelayEnvironmentProvider>
			</Placeholder>
		</ErrorBoundary>
	);
};
